import { injectable } from 'inversify'
import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { ok, err } from '@xlearn/common'
import { Quiz2 } from './quiz'
import { LoadingPhase, QuizQuery } from './quiz-query'

export const QuizStoreModuleSymbol = Symbol.for('QuizStoreModule');

export type FindQuizError = 'quizzes-not-loaded' | 'quiz-not-found'

@injectable()
@Module({
  namespaced: true,
  name: 'quiz',
  store,
  dynamic: true
})
export class QuizStoreModule extends VuexModule implements QuizQuery {

  private phase: LoadingPhase = 'none'  
  private loadedQuizzes: Quiz2[] = []

  @Mutation
  public startLoading() {
    this.phase = 'loading';
    this.loadedQuizzes = [];
  }

  @Mutation
  public finishLoading(quizzes: Quiz2[]) {
    this.loadedQuizzes = quizzes;
    this.phase = 'loaded';
  }

  get findQuiz() {

    const self = this
    return function (id: string) {
      
      if (self.loadingPhase !== 'loaded') {
        return err('quizzes-not-loaded' as FindQuizError)
      }

      const found = self.loadedQuizzes.find(x => x.id === id)
      if (!found) {
        return err('quiz-not-found' as FindQuizError)
      }

      return ok(found)
    }
  }

  get quizzes() {
    return this.loadedQuizzes
  }

  get loadingPhase() {
    return this.phase
  }
}

export default getModule(QuizStoreModule);
